import React, { PureComponent } from 'react';
import cn from 'classnames';
import { number, bool, string, oneOfType } from 'prop-types';

class PageItem extends PureComponent {
  static propTypes = {
    page: oneOfType([number, string]).isRequired,
    active: bool,
  };

  static defaultProps = {
    active: false,
  };

  handleClick = e => {
    this.props.page !== '…' && this.props.onClick(e, this.props.page);
  };

  render() {
    const { page, active, last } = this.props;
    const Tag = page === '…' ? 'span' : 'a';
    const pageItemClasses = cn(
      'page-item',
      {
        'page-delimiter': page === '…',
        active,
        last,
      }
    );
    return (
      <li className={pageItemClasses}>
        <Tag className="page-link" onClick={this.handleClick}>
          {page}
        </Tag>
      </li>
    );
  }
}

export default PageItem;
